import axios from "./api"

export const subscriptionApi = {
    getBillingPortalRoute() {
        return axios.get(`/billing-portal`);
    },
    getPlans() {
        return axios.get(`/api/subscriptions/plans`);
    },
    getActivePlan(request) {
        return axios.get(`/api/users/${request.user_id}/plan`);
    },
    getCheckoutSession(request) {
        return axios.get(`/api/subscriptions/checkout?product_id=${request.product_id}&price_id=${request.price_id}`);
    },
    getRecentSubscription(request) {
        return axios.get(`/api/subscriptions/recent`);
    },
}
